<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <div style="display: flex; align-items: center; width: 100%; justify-content: center">
          <img
            src="@/assets/logo.png"
            alt="KeyReply Logo"
            class="login-logo"
            style="width: 20%; height: auto"
          />
        </div>
        <h1 class="login-title">Welcome back to KeyReply</h1>
      </div>
      <el-button type="primary" @click="handleLogin" round native-type="submit" style="width: 100%"
        >Continue</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Auth0CustomLoginPopup",
  methods: {
    handleLogin() {
      this.$auth.loginWithPopup();
    },
  },
};
</script>

<style>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
  padding: 40px;
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.error {
  color: red;
  font-size: 0.8rem;
}

.forgot-password-dialog {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
}

.mfa-dialog {
  background: white;
  padding: 80px 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
}

.mfa-qr {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.rounded-input .el-input__inner {
  border-radius: 20px; /* or any value you like */
}
</style>
